exports.default = {
  case_upload_image: '上傳圖片',
  case_recreate_mode: '復刻模式',
  case_reference_mode: '參考復刻',
  case_reference_hint: '參考案例的創意與構圖，結合上傳圖片生成',
  case_description: '描述',
  case_description_placeholder: '請輸入要求',
  title_brand: 'PAITEAMS',
  title: 'AI設計師',
  recents: '最近',
  preset_categories: '預設分類',
  show_category_presets: '查看{name}預設',
  category_default_preset_unavailable: '此分類暫無可用的預設配置',
  category_presets_empty: '此分類暫無預設',
  category_presets_load_failed: '預設分類載入失敗',
  retry_category_presets: '重試',
  no_recents: '暫無圖片生成會話',
  new_image_conversation: '圖片生成會話',
  model: '模型',
  auto_model: '自動選擇模型',
  auto_model_desc: '自動為您的任務選擇最佳圖片模型',
  model_default_desc: '適合圖片生成、編輯和視覺創作',
  no_image_models: '暫無可用圖片模型',
  settings: '設定',
  image_size: '圖片尺寸',
  aspect_ratio: '寬高比',
  preset_size: '預設尺寸',
  custom_pixels: '自訂像素',
  custom_pixels_current: '目前尺寸',
  custom_pixels_unit: '像素',
  custom_pixels_width_limit: '寬度範圍',
  custom_pixels_height_limit: '高度範圍',
  custom_pixels_total_limit: '總像素範圍',
  custom_pixels_step_limit: '調整步長',
  custom_pixels_ratio_limit: '長短邊比',
  custom_pixels_within_limits: '符合模型限制',
  width: '寬度',
  height: '高度',
  custom_pixels_range: '寬 {minWidth}–{maxWidth} px，高 {minHeight}–{maxHeight} px，步長 {widthStep}/{heightStep}',
  custom_pixels_limit: '總像素 {min}–{max}',
  custom_pixels_required: '請輸入寬度和高度',
  custom_pixels_integer: '寬度和高度必須是正整數',
  custom_pixels_width_range: '寬度必須在 {min}–{max} px 範圍內',
  custom_pixels_height_range: '高度必須在 {min}–{max} px 範圍內',
  custom_pixels_width_step: '寬度必須按 {step} px 對齊',
  custom_pixels_height_step: '高度必須按 {step} px 對齊',
  custom_pixels_min_total: '總像素不能小於 {min}',
  custom_pixels_max_total: '總像素不能超過 {max}',
  custom_pixels_min_ratio: '寬高比不能小於 {min}:1',
  custom_pixels_max_ratio: '長短邊比不能超過 {max}:1',
  custom_pixels_invalid: '自訂像素不符合目前模型限制',
  auto_style: '自動風格',
  search_style: '搜尋風格...',
  camera: '相機',
  camera_body: '機身',
  lens: '鏡頭',
  focal_length: '焦距',
  aperture: '光圈',
  auto_prompt: '自動提示詞',
  prompt_placeholder: '一隻可愛的小貓在玩毛線球',
  generate: '生成',
  quick_apps: '快捷應用',
  view_all: '查看全部',
  no_cases: '暫無案例',
  all: '全部',
  album: '專輯',
  album_case_count: '共 {count} 個作品',
  recommended_albums: '推薦專輯',
  search_related_albums: '相關專輯',
  search_related_cases: '相關案例',
  search_case_count: '找到 {count} 個案例',
  clear_search: '清除搜尋',
  back_to_image_generation: '返回 AI 圖片',
  sort_cases: '案例排序',
  sort_popular: '熱門',
  sort_latest: '最新',
  sort_default: '預設',
  case_inspiration: '靈感',
  case_short: '短片',
  case_activity: '活動',
  case_search_placeholder: '搜尋靈感',
  hot_category_previous: '上一組熱門案例',
  hot_category_next: '下一組熱門案例',
  hot_category_empty: '此分類暫無案例',
  prompt: '提示詞',
  image_prompt: '圖片提示詞',
  quality: '品質',
  size: '尺寸',
  recreate: '重新建立',
  same_style: '做同款',
  use_as_reference: '用作參考圖',
  more: '更多',
  previous_case: '上一張',
  next_case: '下一張',
  case_detail: '案例詳情',
  loading: '載入中',
  conversation: '對話過程',
  you: '你',
  assistant: '助手',
  continue_conversation: '繼續對話',
  make_same: '做同款',
  conversation_unavailable: '此案例暫無可繼續對話的內容',
  conversation_create_failed: '新會話建立失敗',
  reference_image_unavailable: '該案例暫不能作為參考圖',
  video: '生成影片',
  download: '下載',
  zoom: '放大',
  edit: '編輯',
  save: '儲存',
  copy: '複製',
  max_upload_images: '最多上傳 {count} 張參考圖',
  reference_image_upload_hint: '單張圖片大小不超過 20MB，目前模型最多上傳 {count} 張參考圖。',
  reference_image_limit_exceeded: '目前模型最多支援 {max} 張參考圖，已選擇 {actual} 張，請移除 {remove} 張。',
  invalid_image_format: '圖片格式必須是 PNG、JPEG、JPG 或 WebP',
  image_size_limit: '圖片大小不能超過 20MB',
  upload_failed: '圖片上傳失敗',
  no_entry_agent: '未找到圖片生成入口智能體',
  no_image_model_selected: '請選擇圖片模型',
  quick_background_remove: '背景移除',
  quick_background_remove_prompt: '移除圖片背景，保留主體並讓邊緣自然乾淨。',
  quick_magic_retouch: '魔法橡皮擦',
  quick_magic_retouch_prompt: '修復圖片中不需要的區域，保持畫面材質和光線自然。',
  quick_scene_redraw: '魔法重繪',
  quick_scene_redraw_prompt: '重新繪製畫面，增強細節、氛圍和構圖完整度。',
  quick_photo_deblur: '照片去模糊',
  quick_photo_deblur_prompt: '提升照片清晰度，恢復人物、物體和背景細節。',
  quick_image_expand: '圖片擴展',
  quick_image_expand_prompt: '自然擴展圖片邊界，延展背景和場景內容。',
  skills: '技能',
  all_skills: '全部技能',
  loading_skills: '技能載入中',
  no_skills: '暫無可用技能',
  recently_opened: '最近開啟',
  back_to_categories: '返回分類'
}
